import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 p-25" }
const _hoisted_4 = { class: "position-relative table-src-form me-0" }
const _hoisted_5 = {
  class: "d-flex flex-wrap align-items-center",
  style: {"gap":"15px"}
}
const _hoisted_6 = { class: "dropdown select-dropdown" }
const _hoisted_7 = {
  class: "dropdown-toggle border text-body rounded-2 bg-transparent",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_8 = { class: "dropdown-menu dropdown-menu-end bg-white border-0 box-shadow py-3" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "default-table-area style-two py-15 individual-asset-performance" }
const _hoisted_11 = { class: "table-responsive" }
const _hoisted_12 = { class: "table align-middle" }
const _hoisted_13 = {
  key: 0,
  class: "material-symbols-outlined sort-icon position-relative top-6"
}
const _hoisted_14 = {
  key: 0,
  class: "material-symbols-outlined sort-icon"
}
const _hoisted_15 = {
  key: 0,
  class: "material-symbols-outlined sort-icon"
}
const _hoisted_16 = {
  key: 0,
  class: "material-symbols-outlined sort-icon"
}
const _hoisted_17 = {
  key: 0,
  class: "material-symbols-outlined sort-icon"
}
const _hoisted_18 = {
  key: 0,
  class: "material-symbols-outlined sort-icon"
}
const _hoisted_19 = {
  key: 0,
  class: "material-symbols-outlined sort-icon"
}
const _hoisted_20 = { class: "text-body" }
const _hoisted_21 = {
  class: "d-flex align-items-center",
  style: {"gap":"8px"}
}
const _hoisted_22 = ["src", "alt"]
const _hoisted_23 = { class: "fw-medium text-secondary fs-13" }
const _hoisted_24 = { class: "fw-normal fs-12 text-body" }
const _hoisted_25 = { class: "fw-medium" }
const _hoisted_26 = { class: "text-secondary fw-medium" }
const _hoisted_27 = { class: "text-secondary fw-medium" }
const _hoisted_28 = { class: "overflow-hidden" }
const _hoisted_29 = {
  class: "position-relative",
  style: {"top":"9px"}
}
const _hoisted_30 = { key: 0 }
const _hoisted_31 = {
  class: "d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap p-4",
  style: {"padding-top":"15px !important"}
}
const _hoisted_32 = { class: "fs-13" }
const _hoisted_33 = { "aria-label": "Page navigation example" }
const _hoisted_34 = { class: "pagination mb-0 justify-content-center" }
const _hoisted_35 = { class: "page-item" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "page-item" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = {
  class: "modal fade",
  id: "addCryptoModal",
  tabindex: "-1",
  "aria-labelledby": "addCryptoModalLabel",
  "aria-hidden": "true"
}
const _hoisted_41 = {
  class: "modal-dialog modal-dialog-centered",
  style: {"max-width":"550px"}
}
const _hoisted_42 = { class: "modal-content rounded-0" }
const _hoisted_43 = { class: "modal-body p-4" }
const _hoisted_44 = { class: "row" }
const _hoisted_45 = { class: "col-lg-6" }
const _hoisted_46 = { class: "form-group mb-4" }
const _hoisted_47 = { class: "col-lg-6" }
const _hoisted_48 = { class: "form-group mb-4" }
const _hoisted_49 = { class: "col-lg-6" }
const _hoisted_50 = { class: "form-group mb-4" }
const _hoisted_51 = { class: "col-lg-6" }
const _hoisted_52 = { class: "form-group mb-4" }
const _hoisted_53 = { class: "col-lg-6" }
const _hoisted_54 = { class: "form-group mb-4" }
const _hoisted_55 = { class: "col-lg-6" }
const _hoisted_56 = { class: "form-group mb-4" }
const _hoisted_57 = { class: "col-lg-6" }
const _hoisted_58 = { class: "form-group mb-4" }
const _hoisted_59 = { class: "col-lg-6" }
const _hoisted_60 = { class: "form-group mb-4" }
const _hoisted_61 = { class: "col-lg-12" }
const _hoisted_62 = { class: "mb-3" }
const _hoisted_63 = { class: "d-fslex align-items-center" }
const _hoisted_64 = { class: "avatar-upload mw-100" }
const _hoisted_65 = { class: "mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control border-0",
            placeholder: "Search here....",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.filterAssets && _ctx.filterAssets(...args)))
          }, null, 544), [
            [_vModelText, _ctx.searchQuery]
          ]),
          _cache[21] || (_cache[21] = _createElementVNode("i", { class: "material-symbols-outlined position-absolute top-50 start-0 translate-middle-y text-secondary" }, " search ", -1))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[22] || (_cache[22] = _createElementVNode("button", {
            class: "btn btn-outline-primary fw-medium rounded-3 hover-bg",
            "data-bs-toggle": "modal",
            "data-bs-target": "#addCryptoModal"
          }, [
            _createElementVNode("span", {
              class: "d-flex align-items-center",
              style: {"gap":"5px"}
            }, [
              _createElementVNode("i", { class: "ri-add-line d-none d-sm-inline-block fs-20 lh-1" }),
              _createElementVNode("span", null, "Add Crypto")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", _hoisted_7, _toDisplayString(_ctx.selectedTimeRange), 1),
            _createElementVNode("ul", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeRanges, (range) => {
                return (_openBlock(), _createElementBlock("li", { key: range }, [
                  _createElementVNode("button", {
                    class: "dropdown-item text-secondary py-2 px-3",
                    onClick: ($event: any) => (_ctx.changeTimeRange(range))
                  }, _toDisplayString(range), 9, _hoisted_9)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("table", _hoisted_12, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sortBy('name')))
                }, [
                  _cache[23] || (_cache[23] = _createTextVNode(" Name ", -1)),
                  (_ctx.sortColumn === 'name')
                    ? (_openBlock(), _createElementBlock("i", _hoisted_13, _toDisplayString(_ctx.sortDirection === "asc"
                        ? "arrow_drop_up"
                        : "arrow_drop_down"), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sortBy('currentPrice')))
                }, [
                  _cache[24] || (_cache[24] = _createTextVNode(" Price ", -1)),
                  (_ctx.sortColumn === 'currentPrice')
                    ? (_openBlock(), _createElementBlock("i", _hoisted_14, _toDisplayString(_ctx.sortDirection === "asc"
                        ? "arrow_drop_up"
                        : "arrow_drop_down"), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sortBy('oneHourChange')))
                }, [
                  _cache[25] || (_cache[25] = _createTextVNode(" 1h % ", -1)),
                  (_ctx.sortColumn === 'oneHourChange')
                    ? (_openBlock(), _createElementBlock("i", _hoisted_15, _toDisplayString(_ctx.sortDirection === "asc"
                        ? "arrow_drop_up"
                        : "arrow_drop_down"), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sortBy('twentyFourHourChange')))
                }, [
                  _cache[26] || (_cache[26] = _createTextVNode(" 24h % ", -1)),
                  (_ctx.sortColumn === 'twentyFourHourChange')
                    ? (_openBlock(), _createElementBlock("i", _hoisted_16, _toDisplayString(_ctx.sortDirection === "asc"
                        ? "arrow_drop_up"
                        : "arrow_drop_down"), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sortBy('sevenDayChange')))
                }, [
                  _cache[27] || (_cache[27] = _createTextVNode(" 7d % ", -1)),
                  (_ctx.sortColumn === 'sevenDayChange')
                    ? (_openBlock(), _createElementBlock("i", _hoisted_17, _toDisplayString(_ctx.sortDirection === "asc"
                        ? "arrow_drop_up"
                        : "arrow_drop_down"), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sortBy('marketCap')))
                }, [
                  _cache[28] || (_cache[28] = _createTextVNode(" Market Cap ", -1)),
                  (_ctx.sortColumn === 'marketCap')
                    ? (_openBlock(), _createElementBlock("i", _hoisted_18, _toDisplayString(_ctx.sortDirection === "asc"
                        ? "arrow_drop_up"
                        : "arrow_drop_down"), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sortBy('volume24h')))
                }, [
                  _cache[29] || (_cache[29] = _createTextVNode(" Volume (24h) ", -1)),
                  (_ctx.sortColumn === 'volume24h')
                    ? (_openBlock(), _createElementBlock("i", _hoisted_19, _toDisplayString(_ctx.sortDirection === "asc"
                        ? "arrow_drop_up"
                        : "arrow_drop_down"), 1))
                    : _createCommentVNode("", true)
                ]),
                _cache[30] || (_cache[30] = _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary"
                }, "Last 7 Days", -1))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedAssets, (asset) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: asset.id
                }, [
                  _createElementVNode("td", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("img", {
                        src: asset.image,
                        style: {"width":"22px","height":"22px"},
                        alt: asset.name
                      }, null, 8, _hoisted_22),
                      _createElementVNode("span", _hoisted_23, [
                        _createTextVNode(_toDisplayString(asset.name) + " ", 1),
                        _createElementVNode("span", _hoisted_24, " (" + _toDisplayString(asset.symbol) + ") ", 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.formatCurrency(asset.currentPrice)), 1),
                  _createElementVNode("td", {
                    class: _normalizeClass([_ctx.getChangeClass(asset.oneHourChange), "fw-medium"])
                  }, _toDisplayString(_ctx.formatPercentage(asset.oneHourChange)), 3),
                  _createElementVNode("td", {
                    class: _normalizeClass([_ctx.getChangeClass(asset.twentyFourHourChange), "fw-medium"])
                  }, _toDisplayString(_ctx.formatPercentage(asset.twentyFourHourChange)), 3),
                  _createElementVNode("td", {
                    class: _normalizeClass([_ctx.getChangeClass(asset.sevenDayChange), "fw-medium"])
                  }, _toDisplayString(_ctx.formatPercentage(asset.sevenDayChange)), 3),
                  _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.formatLargeCurrency(asset.marketCap)), 1),
                  _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.formatLargeCurrency(asset.volume24h)), 1),
                  _createElementVNode("td", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      (_ctx.isClient)
                        ? (_openBlock(), _createBlock(_component_apexchart, {
                            key: 0,
                            type: "line",
                            height: "50",
                            width: "112",
                            options: _ctx.getChartOptions(asset),
                            series: _ctx.getChartSeries(asset)
                          }, null, 8, ["options", "series"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              }), 128)),
              (_ctx.filteredAssets.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [...(_cache[31] || (_cache[31] = [
                    _createElementVNode("td", {
                      colspan: "8",
                      class: "text-center py-4 text-secondary"
                    }, " No cryptocurrencies found ", -1)
                  ]))]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.showingRange), 1),
          _createElementVNode("nav", _hoisted_33, [
            _createElementVNode("ul", _hoisted_34, [
              _createElementVNode("li", _hoisted_35, [
                _createElementVNode("button", {
                  class: "page-link icon hover-bg",
                  "aria-label": "Previous",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args))),
                  disabled: _ctx.currentPage === 1
                }, [...(_cache[32] || (_cache[32] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_left", -1)
                ]))], 8, _hoisted_36)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visiblePages, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "page-item",
                  key: page
                }, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["page-link", { active: _ctx.currentPage === page }]),
                    onClick: ($event: any) => (_ctx.goToPage(page))
                  }, _toDisplayString(page), 11, _hoisted_37)
                ]))
              }), 128)),
              _createElementVNode("li", _hoisted_38, [
                _createElementVNode("button", {
                  class: "page-link icon hover-bg",
                  "aria-label": "Next",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
                  disabled: _ctx.currentPage === _ctx.totalPages
                }, [...(_cache[33] || (_cache[33] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_right", -1)
                ]))], 8, _hoisted_39)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _cache[45] || (_cache[45] = _createElementVNode("div", { class: "modal-header border-0 p-4 border-bottom" }, [
              _createElementVNode("h1", {
                class: "modal-title fs-18",
                id: "addCryptoModalLabel"
              }, " Add New Crypto "),
              _createElementVNode("button", {
                type: "button",
                class: "btn-close campaigns-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              })
            ], -1)),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("form", {
                onSubmit: _cache[20] || (_cache[20] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addNewCrypto && _ctx.addNewCrypto(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _cache[34] || (_cache[34] = _createElementVNode("label", { class: "label text-secondary" }, "Name", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control h-60 border-border-color",
                        placeholder: "Enter Asset",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newCrypto.name) = $event)),
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.newCrypto.name]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _cache[35] || (_cache[35] = _createElementVNode("label", { class: "label text-secondary" }, "Symbol", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control h-60 border-border-color",
                        placeholder: "e.g. BTC",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.newCrypto.symbol) = $event)),
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.newCrypto.symbol]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _cache[36] || (_cache[36] = _createElementVNode("label", { class: "label text-secondary" }, "Price (USD)", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "form-control h-60 border-border-color",
                        placeholder: "Enter Price",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.newCrypto.currentPrice) = $event)),
                        step: "0.0001",
                        min: "0",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.newCrypto.currentPrice]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _cache[37] || (_cache[37] = _createElementVNode("label", { class: "label text-secondary" }, "1h %", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "form-control h-60 border-border-color",
                        placeholder: "Enter 1h change",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.newCrypto.oneHourChange) = $event)),
                        step: "0.01",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.newCrypto.oneHourChange]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _cache[38] || (_cache[38] = _createElementVNode("label", { class: "label text-secondary" }, "24h %", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "form-control h-60 border-border-color",
                        placeholder: "Enter 24h change",
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.newCrypto.twentyFourHourChange) = $event)),
                        step: "0.01",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.newCrypto.twentyFourHourChange]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _cache[39] || (_cache[39] = _createElementVNode("label", { class: "label text-secondary" }, "7d %", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "form-control h-60 border-border-color",
                        placeholder: "Enter 7d change",
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newCrypto.sevenDayChange) = $event)),
                        step: "0.01",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.newCrypto.sevenDayChange]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _cache[40] || (_cache[40] = _createElementVNode("label", { class: "label text-secondary" }, "Market Cap", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "form-control h-60 border-border-color",
                        placeholder: "Enter Market Cap",
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.newCrypto.marketCap) = $event)),
                        min: "0",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.newCrypto.marketCap]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _cache[41] || (_cache[41] = _createElementVNode("label", { class: "label text-secondary" }, "Volume (24h)", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "form-control h-60 border-border-color",
                        placeholder: "Enter Volume (24h)",
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.newCrypto.volume24h) = $event)),
                        min: "0",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.newCrypto.volume24h]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, [
                      _cache[43] || (_cache[43] = _createElementVNode("label", { class: "label text-secondary" }, "Image", -1)),
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("div", _hoisted_65, [
                            _createElementVNode("input", {
                              type: "file",
                              id: "imageUpload",
                              class: "form-control h-60",
                              accept: ".png, .jpg, .jpeg",
                              onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.handleImageUpload && _ctx.handleImageUpload(...args))),
                              style: {"padding-top":"18px"}
                            }, null, 32)
                          ]),
                          _cache[42] || (_cache[42] = _createElementVNode("span", { class: "fs-12 mb-4 d-block" }, " Please upload your image with a size of 50px x 50px ", -1)),
                          _createElementVNode("div", {
                            id: "imagePreview",
                            class: "rounded-circle",
                            style: _normalizeStyle({
                              backgroundImage: `url(${_ctx.imagePreview})`,
                              backgroundSize: 'cover',
                              backgroundPosition: 'center',
                              width: '50px',
                              height: '50px',
                            })
                          }, null, 4)
                        ])
                      ])
                    ])
                  ]),
                  _cache[44] || (_cache[44] = _createStaticVNode("<div class=\"col-lg-12\"><div class=\"d-flex justify-content-end flex-wrap gap-3\"><button type=\"button\" class=\"btn btn-danger py-2 px-4 fw-medium fs-16 text-white\" data-bs-dismiss=\"modal\"> Cancel </button><button type=\"submit\" class=\"btn btn-primary py-2 px-4 fw-medium fs-16\" data-bs-dismiss=\"modal\"><i class=\"ri-add-line text-white fw-medium\"></i> Create </button></div></div>", 1))
                ])
              ], 32)
            ])
          ])
        ])
      ])
    ])
  ]))
}